var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useField, useFormikContext } from "formik";
import cs from "date-fns/locale/cs";
import { CSLocaleUtils, formatDate } from "../../../utils/date";
import { useWindowSize } from "../../../utils/use-window-size";
export var FormItemDateRange = function (_a) {
    var name = _a.name, label = _a.label, tooltip = _a.tooltip, rest = __rest(_a, ["name", "label", "tooltip"]);
    var setFieldValue = useFormikContext().setFieldValue;
    var _b = __read(useField(name), 2), field = _b[0], meta = _b[1];
    var value = field.value;
    var _c = useWindowSize(), width = _c.width, height = _c.height;
    var handleChange = function (date, name) {
        if (date && (date === null || date === void 0 ? void 0 : date.toString()) !== "Invalid Date") {
            setFieldValue(name, formatDate(date));
        }
    };
    var DateInput = function (_a) {
        var name = _a.name, label = _a.label, value = _a.value, placeholder = _a.placeholder, onClick = _a.onClick, onChange = _a.onChange;
        var _b = __read(useField(name !== null && name !== void 0 ? name : ""), 2), field = _b[0], meta = _b[1];
        var touched = meta.touched, error = meta.error;
        var errorText = touched && error ? error : null;
        return (React.createElement("div", { className: "form-item-date-range-input" },
            React.createElement("label", { className: "form-item-date-range-input__label" }, label),
            React.createElement("input", { type: "text", className: "form-item-date-range-input__control", value: value, onClick: onClick, onChange: onChange, placeholder: placeholder, readOnly: true }),
            errorText && (React.createElement("div", { className: "form-item-date-range-input__error scroll_to_error" }, errorText))));
    };
    return (React.createElement("div", { className: "form-item-date-range" },
        React.createElement("div", { className: "form-item-date-range__legend_box" },
            React.createElement("label", { className: "form-item-date-range__legend" }, label),
            tooltip ? (React.createElement("div", { className: "form-item-date-range__tooltip" },
                "i",
                React.createElement("div", { className: "form-item-date-range__tooltip_window" }, tooltip))) : (React.createElement(React.Fragment, null))),
        React.createElement("div", { className: "form-item-date-range__wrapper" },
            React.createElement(MuiPickersUtilsProvider, { locale: cs, utils: CSLocaleUtils },
                React.createElement("div", { className: "form-item-date-range__input" },
                    React.createElement(DatePicker, __assign({ name: name + ".from", label: "Zahájení:", value: value.from, onChange: function (value) { return handleChange(value, name + ".from"); }, TextFieldComponent: function (props) { return DateInput(props); }, autoOk: true, variant: width < 600 || height < 600 ? "dialog" : "inline" }, rest))),
                React.createElement("div", { className: "form-item-date-range__input" },
                    React.createElement(DatePicker, __assign({ name: name + ".to", label: "Ukončení:", value: value.to, onChange: function (value) { return handleChange(value, name + ".to"); }, TextFieldComponent: function (props) { return DateInput(props); }, autoOk: true, variant: width < 600 || height < 600 ? "dialog" : "inline" }, rest)))))));
};
